export default "__VITE_ASSET__bJjE_jwp__"